import type { StageParameters } from '../stage/stage-parameters';
import type { ConfigurationParameter } from './configuration-parameter';
import type { AuthenticationEnvSetting } from './settings/authentication';
import { getAuthenticationConfig } from './settings/authentication';
import type { GraphQLEndpointEnvSetting } from './settings/graphql-endpoint';
import { getGraphQLEndpoint } from './settings/graphql-endpoint';
import { getOpGraphQLEndpoint } from './settings/op-graphql-endpoint';
import type { TelemetryEnvSetting } from './settings/telemetry';
import { getTelemetryConfig } from './settings/telemetry';

// applies to all apps
export type AppEnvironment = {
  graphQLEndpoint: GraphQLEndpointEnvSetting;
  opGraphQLEndpoint: GraphQLEndpointEnvSetting;
  authenticationConfig: AuthenticationEnvSetting;
  telemetryConfig: TelemetryEnvSetting;
};

export type AppConfig = (
  ConfigurationParameter<typeof getGraphQLEndpoint> &
  ConfigurationParameter<typeof getAuthenticationConfig> &
  ConfigurationParameter<typeof getTelemetryConfig>
);

export const getAppEnvironment = (
  stageParams: StageParameters,
  { backendApi, clientId, resourceName, redirectUris, adapter }: AppConfig,
): AppEnvironment => ({
  graphQLEndpoint: getGraphQLEndpoint(stageParams, { backendApi }),
  opGraphQLEndpoint: getOpGraphQLEndpoint(stageParams),
  authenticationConfig: getAuthenticationConfig(stageParams, { clientId, resourceName, redirectUris, adapter }),
  telemetryConfig: getTelemetryConfig(stageParams),
});

